import { UserOrganization } from '@/modules/Users/domain';
import { DynamIQLogo } from '../Icons';
import { Footer } from '../LoggedLayout/components';
import OrganizationPicker from '../OrganizationPickerModal/OrganizationPicker';

type OrganizationPickerProps = {
  organizations: UserOrganization[];
  onSelect: (organizationId: number) => void;
};

export default function OrganizationPickerPage({
  organizations,
  onSelect,
}: OrganizationPickerProps) {
  return (
    <main className="flex h-full flex-col justify-between bg-gradient">
      <div className="pl-5 pt-5 text-white">
        <DynamIQLogo />
      </div>
      <div className="flex flex-1 items-center justify-center">
        <OrganizationPicker organizations={organizations} onSelect={onSelect} />
      </div>
      <Footer />
    </main>
  );
}
